import { getID } from "src/libs/utilities"

const delimiter = (): any[] => {
    return [
        {
            id: getID("delimiter"),
            title: "Not exists", 
            isDisabled: true,
            edges: [],
        },
        {
            id: getID("delimiter"),
            title: "Default", 
            isDisabled: false,
            edges: [],
        },
        {
            id: getID("delimiter"),
            title: "Neon", 
            height: 3,
            width: "50%",
            x: "25%",
            edges: [],
            bg: "linear-gradient(0.252turn, rgba(65, 144, 255, 1) 1%, rgba(222, 55, 255, 1) 33%, rgba(255, 66, 66, 1) 73%, rgba(255, 161, 0, 1) 100%, rgba(65, 144, 255, 1) 100%)",
            style: {
                "borderRadius": "0px 0px 0px 0px", 
                "borderColor": "transparent",
                "borderStyle": "solid",
                "borderWidth": 0,
                "height": 3,
                "width": "50%",
                "left": "25%"
            }
        },
        {
            id: getID("delimiter"),
            title: "Block", 
            height: 5,
            width: 200,
            x: "calc(50% - 100px)",
            bg: "var(--force-contast-color)",
            edges: [],
            style: {
                "borderRadius": "0px 0px 0px 0px", 
                "borderColor": "transparent",
                "borderStyle": "solid",
                "borderWidth": 0 
            }
        },
        {
            id: getID("delimiter"),
            title: "Single torn paper", 
            isDisabled: false,
            height: 70,
            z: 20,
            style: { "backgroundColor": "transparent" , pointerEvents: "none" },
            edges: [
                { "type": 3, class_name: "untouchble", "position": { "rotate": 0, "top": 0 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: "Pile of torn papers", 
            isDisabled: false,
            animated: "none",
            z: 20,
            style: { "backgroundColor": "transparent" },
            edges: [
                { "type": 1, class_name: "untouchble", "position": { "rotate": -7, "top": -64 } },
                { "type": 3, class_name: "untouchble", "position": { "rotate": 1, "top": -45 } }
            ],
            height: 90, 
            "width": 2000,
            position: {
                height: 90, 
            "width": 2000,
            },
            dimentions: {
                1920: {
                    height: 90 ,
                    "width": 2000,
                },
                360: {
                    height: 33, 
                    "width": 1000,       
                }
            }
        },
        {
            id: getID("delimiter"),
            title: "Arabesque 1", 
            isDisabled: false,
            "height": 25, 
            "style": { "backgroundColor": "transparent",  "height": 25 },
            "edges": [
                { 
                    "type": 10, 
                    "position": { 
                        "height": 25 
                    } 
                }
            ]
        },
        {
            id: getID("delimiter"),
            title: "Arabesque 1", 
            isDisabled: false,
            "height": 33, 
            "style": { "backgroundColor": "transparent",  "height": 33 },
            "edges": [
                { 
                    "type": 11, 
                    "position": { 
                        "height": 33 
                    } 
                }
            ]
        },
        {
            id: getID("delimiter"),
            title: "Vignette 1", 
            isDisabled: false,
            "height": 25,
            "z": 20,
            "style": { "backgroundColor": "transparent",  "height": 25 },
            "edges": [
                { 
                    "type": 12, 
                    "position": { 
                        "height": 25 
                    } 
                }
            ]
        },
        {
            id: getID("delimiter"),
            title: "Anansi", 
            isDisabled: false,
            "height": 35,
            "z": 20,
            "style": { "backgroundColor": "transparent",  "height": 35 },
            "edges": [
                { 
                    "type": 13, 
                    "position": { 
                        "height": 35 
                    } 
                }
            ]
        },
        {
            id: getID("delimiter"),
            title: "Roses", 
            isDisabled: false,
            "height": 35,
            "z": 20,
            "style": { "backgroundColor": "transparent",  "height": 35 },
            "edges": [
                { 
                    "type": 14, 
                    "position": { 
                        "height": 35 
                    } 
                }
            ]
        },
        {
            id: getID("delimiter"),
            title: "Garland", 
            isDisabled: false,
            "height": 45,
            "z": 20,
            "style": { "backgroundColor": "transparent",  "height": 45 },
            "edges": [
                { 
                    "type": 15, 
                    "position": { 
                        "height": 45 
                    } 
                }
            ]
        },
        {
            id: getID("delimiter"),
            title: "Arrows", 
            isDisabled: false,
            "height": 35,
            "z": 20,
            "style": { "backgroundColor": "transparent",  "height": 35 },
            "edges": [
                { 
                    "type": 16, 
                    "position": { 
                        "height": 35 
                    } 
                }
            ]
        },
        {
            id: getID("delimiter"),
            title: " ", 
            isDisabled: false,
            "height": 35,
            "z": 20, 
            "style": { "backgroundColor": "transparent",  "height": 35 },
            "edges": [ 
                { "type": 17, "position": { "height": 35, "z": 2 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: " ", 
            isDisabled: false,
            "height": 20,
            "z": 20, 
            "style": { "backgroundColor": "transparent",  "height": 35 },
            "edges": [ 
                { "type": 18, "position": { "height": 20, "z": 2 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: "Flagies", 
            isDisabled: false,
            "height": 20,
            "z": 20, 
            "style": { "backgroundColor": "transparent",  "height": 35 },
            "edges": [ 
                { "type": 19, "position": { "height": 20, "z": 2 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: "star 1", 
            isDisabled: false,
            "height": 20,
            "z": 20,
            "style": { "backgroundColor": "transparent", "height": 45 },
            "edges": [ 
                { "type": 20, "position": { "height": 45, "z": 2 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: "Jupiter", 
            isDisabled: false,
            "height": 45,
            "z": 20,
            "style": { "backgroundColor": "transparent", "height": 45 },
            "edges": [ 
                { "type": 21, "position": { "height": 45, "z": 2 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: "sunny", 
            isDisabled: false,
            "height": 55,
            "z": 20,
            "style": { "backgroundColor": "transparent", "height": 55 },
            "edges": [ 
                { "type": 22, "position": { "height": 55, "z": 2 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: "stars 1", 
            isDisabled: false,
            "height": 35,
            "z": 20,
            "style": { "backgroundColor": "transparent", "height": 35 },
            "edges": [ 
                { "type": 23, "position": { "height": 35, "z": 2 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: "stars 2", 
            isDisabled: false,
            "height": 35,
            "z": 20,
            "style": { "backgroundColor": "transparent", "height": 35 },
            "edges": [ 
                { "type": 24, "position": { "height": 35, "z": 2 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: "star 2", 
            isDisabled: false,
            "height": 35,
            "z": 20,
            "style": { "backgroundColor": "transparent", "height": 35 },
            "edges": [ 
                { "type": 25, "position": { "height": 35, "z": 2 } }
            ]
        },
        {
            id: getID("delimiter"),
            title: "crown", 
            isDisabled: false,
            "height": 35,
            "z": 20,
            "style": { "backgroundColor": "transparent", "height": 35 },
            "edges": [ 
                { "type": 26, "position": { "height": 35, "z": 2 } }
            ]
        },
    ]
}
export default delimiter